import { styled } from "@mui/material/styles";

const StyledCartCards = styled("div")(
  ({ theme }) => `  
  position: relative;

  .trip-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.palette.customColor.secondaryFirst}; 
  padding: 12px;
  border: 1px solid ${theme.palette.secondary.main}; 
  width: 94.5%;
  // min-width: 400px;
  @media screen and (max-width: 760px){
  width: 95%;
  }
  @media screen and (max-width: 426px){
  width: 93%;
  }

}

.box-container {
  display: flex;
  align-items: center;
}

.box-icon {
  color: ${theme.palette.secondary.main}; 
  margin-right: 8px;
  width: 24px;
  height: 24px;
}

.date-details {
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.palette.customColor.secondarySecond};
  margin-top: 4px;
}

.details {
  font-family: 'Lexend', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.palette.primary.main}; 
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.checkbox-custom {
  color: ${theme.palette.primary.main}; 
  cursor: pointer;
}

.edit-icon {
  color: ${theme.palette.primary.main}; 
  cursor: pointer;
  font-size: 20px;
}

.checkbox-custom.Mui-checked {
  color: ${theme.palette.primary.main}; 
}

.addCity, .addDate, .details-1, .details-2, .addCity-2 {
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.palette.secondary.main}; 
  cursor: pointer;
  text-decoration: underline;
  min-width: 60px;
}

.addDate {
  margin-top: 6px;
}

.addCity-1, .addDate-2 {
  font-family: 'Lexend', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.palette.primary.main}; 
  margin-top: 5px;
}


.edit {
  color: ${theme.palette.primary.main};
}

.hotenicon {
  color: ${theme.palette.secondary.main}; 
}

.addIcon-addTrip {
  color: ${theme.palette.secondary.main} !important;
  margin-left: -3px;
  margin-right: 4px;
  font-size: 26px;
}

.trip-container-text {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

  .trip-container {
    display: flex;
    align-items: center;
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    padding: 14px 16px;
    gap: 6px;
    cursor: pointer;
  }

    .heading-7 {
    font-family: 'Lexend', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: ${theme.palette.primary.main}; 
    }

    .heading-8{
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color:${theme.palette.customColor.secondarySecond}
    }

    .loading-spinner-1 {
      position: absolute;
      left: 50%;
      top: 35%;
    }
  `
);

export default StyledCartCards;
